// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../shared/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../shared/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../styles/customMediaQueries.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users_root__iOR9N {
  margin: 20px 20px;
  gap: 24px;

  & .ant-table-wrapper .ant-table-thead th:hover {
    background: #f0f0f0;
  }
}

.Users_datePicker__RGr6\\+ {
  width: 100%;
}

.Users_searchFormContainer__ZpJsN {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  gap: 10px 0;

  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.Users_actionContainer__r1VaQ {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Users_actionIcon__KlCCW {
  display: flex;
  cursor: pointer;
}

.Users_actionsWrapper__gEmmC {
  & .ant-row {
    gap: 10px 0;
    justify-content: flex-end;
  }

  & button {
    width: 100%;
  }
}

.Users_formItem__7fVNN {
  display: flex;
  flex-direction: column;
  gap: 5px;
  
  @media (min-width: 576px) {
    flex-direction: row;
  }

  label {
    white-space: nowrap;
    text-align: left;
    flex-shrink: 0;

    @media (min-width: 576px) {
      min-width: 100px;
      margin-top: 5px;
    }

    @media (min-width: 992px) {
      min-width: 1px;
    }
  }

  .ant-form-item {
    /* width: calc(100% - 50px); */
    margin-bottom: 0;
    flex-grow: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Users/Users.module.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,SAAS;;EAET;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;;EAEX;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;;IAEd;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":["@import \"../../styles/customMediaQueries.css\";\n\n.root {\n  margin: 20px 20px;\n  gap: 24px;\n\n  & :global(.ant-table-wrapper .ant-table-thead th:hover) {\n    background: #f0f0f0;\n  }\n}\n\n.datePicker {\n  width: 100%;\n}\n\n.searchFormContainer {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  gap: 10px 0;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n}\n\n.actionContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.actionIcon {\n  display: flex;\n  cursor: pointer;\n}\n\n.actionsWrapper {\n  & :global(.ant-row) {\n    gap: 10px 0;\n    justify-content: flex-end;\n  }\n\n  & button {\n    width: 100%;\n  }\n}\n\n.formItem {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  \n  @media (min-width: 576px) {\n    flex-direction: row;\n  }\n\n  label {\n    white-space: nowrap;\n    text-align: left;\n    flex-shrink: 0;\n\n    @media (min-width: 576px) {\n      min-width: 100px;\n      margin-top: 5px;\n    }\n\n    @media (min-width: 992px) {\n      min-width: 1px;\n    }\n  }\n\n  :global(.ant-form-item) {\n    /* width: calc(100% - 50px); */\n    margin-bottom: 0;\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Users_root__iOR9N`,
	"datePicker": `Users_datePicker__RGr6+`,
	"searchFormContainer": `Users_searchFormContainer__ZpJsN`,
	"actionContainer": `Users_actionContainer__r1VaQ`,
	"actionIcon": `Users_actionIcon__KlCCW`,
	"actionsWrapper": `Users_actionsWrapper__gEmmC`,
	"formItem": `Users_formItem__7fVNN`
};
export default ___CSS_LOADER_EXPORT___;
